<template>
    <v-form-tile>
        <h2 slot="title">Body Sections</h2>
        <p slot="description" class="text-muted">Add sections to the body of the page to customize the content being
            displayed before the payment form.</p>
        <div slot="content" class="tile">
            <div class="tile-content cursor-pointer" @click="toggleSection">
                <div class="grid-content grid-unstackable">
                    <div class="grid-item"><h3>Body Sections</h3></div>
                    <div class="grid-item no-flex text-right">
                        <v-toggle
                            @input="toggleSection"
                            :selected="page.hasMarkup(sections.body)"
                            :value="true"/>
                    </div>
                </div>
            </div>
            <template v-if="page.hasMarkup(sections.body)">
                <div
                    class="tile-content tile-content-secondary"
                    :key="section.$internalId"
                    v-for="(section, index) in bodySections">
                    <div class="tile-subtitle">
                        <h3>Section {{index + 1}}</h3>
                        <v-icon-button
                            class="no-flex no-padding"
                            type="basic"
                            size="small"
                            :disabled="hasOnlyOneSection"
                            @click="deleteSection(section)"
                            tooltip="Delete">
                            <v-icon icon="trash"/>
                        </v-icon-button>
                    </div>
                    <div class="grid-content">
                        <div class="grid-item grid-item-full">
                            <v-editor
                                class="stack-s"
                                :value="section.content"
                                @input="updateSectionContent(section, $event)"/>
                        </div>
                        <div class="grid-item grid-item-half grid-item-break-half">
                            <color-input
                                label="Background Color"
                                :validate="validate.$each.$iter[page.getBodyMarkupIndex(section)].style.background"
                                @input="updateColor('background', section, $event)"
                                :value="section.style.background"/>
                        </div>
                        <div class="grid-item grid-item-half grid-item-break-half">
                            <color-input
                                label="Font Color"
                                :validate="validate.$each.$iter[page.getBodyMarkupIndex(section)].style.color"
                                @input="updateColor('color', section, $event)"
                                :value="section.style.color"/>
                        </div>
                    </div>
                </div>
                <div class="tile-content tile-content-secondary">
                    <r-button type="link" @click="addSection">Add New Section</r-button>
                </div>
            </template>
        </div>
    </v-form-tile>
</template>

<script>
    import {
        vFormTile, vToggle, vIconButton, vIcon, vEditor,
    } from '@/components/form';
    import CheckoutPageModel, {CheckoutPageMarkupModel} from '@/common/models/checkout-page-model';
    import ColorInput from './color-input';

    export default {
        name: 'body-sections',
        props: {
            /**
             * @type {CheckoutPageModel}
             */
            page: CheckoutPageModel,
            validate: Object,
        },
        components: {
            vFormTile,
            vToggle,
            ColorInput,
            vIconButton,
            vIcon,
            vEditor,
        },
        computed: {
            bodySections() {
                return this.page.markup
                    .filter(v => v.section === CheckoutPageMarkupModel.Sections.body);
            },
            hasOnlyOneSection() {
                return this.bodySections.length < 2;
            },
        },
        data() {
            return {
                sections: {...CheckoutPageMarkupModel.Sections},
            };
        },
        methods: {
            toggleSection() {
                this.$emit('toggle');
            },
            addSection() {
                this.$emit('add-section');
            },
            deleteSection({$internalId}) {
                const index = this.page.markup.findIndex(v => v.$internalId === $internalId);
                if (index > -1) {
                    this.page.markup.splice(index, 1);
                }
                this.triggerUpdate();
            },
            editBodySection($internalId, callback) {
                const markup = this.page.markup.find(v => v.$internalId === $internalId);
                if (markup) {
                    callback(markup);
                    this.triggerUpdate();
                }
            },
            updateColor(target, {$internalId}, value) {
                this.editBodySection($internalId, (markup) => {
                    markup.style[target] = value;
                });
            },
            updateSectionContent({$internalId}, content) {
                this.editBodySection($internalId, (markup) => {
                    markup.content = content;
                });
            },
            triggerUpdate() {
                this.$emit('input', this.page.markup.map(v => v.cloneSelf()));
            },
        },
    };
</script>

<style>
    .quillWrapper {background-color: #ffffff}
</style>
